import axios from "axios";
import { baseUrl } from "../config/EnVariables";
const token = localStorage.getItem("access_token");
const user = JSON.parse(localStorage.getItem("user"));
const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const User = {
  login: (ID, Password) =>
    new Promise((resolve, reject) => {
      axios
        .post("users/signin", {
          email: ID,
          password: Password,
        })
        .then((data) => {
          data.data && localStorage.setItem("user", JSON.stringify(data.data));
          data.token && localStorage.setItem("access_token", data.token);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    }),

  signin: async (ID, Password) => {
    const response = await axios.post(
      `${baseUrl}/signin`,
      {
        username: ID,
        password: Password,
      },
      {
        headers: {
          "Content-type": "application/json",
        },
      }
    );
    return response;
  },

  getLoggedUser: async (token) => {
    const response = await axios.get(`${baseUrl}/users/current-logged-user`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json;charset=UTF-8",
      },
    });
    return response.data;
  },
  getReports: () =>
    axios.get(`${baseUrl}/reporting/dashboard/?branchId=${user.branchId}`, {
      headers,
    }),
  getBranches: () =>
    axios.get(`${baseUrl}/branches`, {
      headers,
    }),

  getOne: (id) => axios.get(`${baseUrl}/users/${id}`, { headers: headers }),

  getAll: () =>
    axios.get(
      `${baseUrl}/users`,

      { headers: headers }
    ),

  remove: (id) => axios.delete(`${baseUrl}/users/${id}`, { headers: headers }),

  // isLoggedIn = async () =>
  //     new Promise((resolve, reject) => {
  //         axios.get('/')
  //             .then((res) => {
  //                 const { loggedIn } = res;
  //                 console.log('Is Logged In', loggedIn);
  //                 if (loggedIn) return resolve();
  //                 localStorage.removeItem('user');
  //                 reject('Not logged in');
  //             })
  //             .catch((err) => {
  //                 reject(err);
  //             });
  //     });

  // getLoggedInUser() {
  //     const sUser = localStorage.getItem('user');
  //     console.log('sUser', JSON.parse(sUser));
  //     return JSON.parse(sUser);
  // }

  // getUser = (ID, date) => axios.get(`users/${ID}?${qs.stringify(date)}`);

  addUser: (data) => axios.post(`${baseUrl}/users`, data, { headers: headers }),

  // updateMe = (data, file, onUploadProgress) =>
  //     new Promise((resolve, reject) => {
  //         axios.patchForm(`users`, data, file, onUploadProgress)
  //             .then((data) => {
  //                 localStorage.setItem('user', JSON.stringify(data.data));
  //                 resolve(data.data);
  //             })
  //             .catch((err) => {
  //                 console.log('Error', err);
  //                 reject(err);
  //             });
  //     });

  update: (data) => axios.put(`${baseUrl}/users`, data, { headers: headers }),

  // forgetPassword = (data) => axios.post('auth/forget', data);

  // resetPassword = (data) => axios.post('auth/reset', data);
};

export default User;
